import React from 'react'
import { DocumentORM, Variant } from 'src/types/types'
import {
  DocumentContextAction,
  ActionCallbacks,
  documentContextOptions,
  useDNADocumentActions,
} from '../DNADocument.actions'
import { DNAContextMenu } from '@alucio/lux-ui'
import useDNADocumentContextMenuActions from './useDNADocumentContextMenuActions'

interface DNADocumentContextMenuProps {
  documentORM: DocumentORM,
  children: React.ReactElement,
  variant?: Variant,
  actions?: DocumentContextAction[],
  onCallback?: (cb: () => void) => void,
  actionCallbacks?: ActionCallbacks,
  pageNumber?: number,
}

const DNADocumentContextMenu: React.FC<DNADocumentContextMenuProps> = (props) => {
  const {
    documentORM,
    actions,
    children,
    variant = Variant.MSL,
    onCallback,
    actionCallbacks,
    pageNumber,
  } = props

  const DNADocumentActions = useDNADocumentActions(onCallback, actionCallbacks)
  const actionsToUse = useDNADocumentContextMenuActions(documentORM, variant)

  const MenuItems = actions?.length || actionsToUse.length
    ? (actions ?? actionsToUse)
      .map(action => {
        const { onPress, status, iconStatus, ...rest } = documentContextOptions[action]
        return (
          <DNAContextMenu.Item
            disabled={actions ? !actions.length : !actionsToUse.length}
            key={action}
            status={status ?? 'primary'}
            iconStatus={iconStatus}
            onPress={DNADocumentActions[action](documentORM, pageNumber)}
            {...rest}
          />
        )
      })
    : (<DNAContextMenu.Item
        title="(No actions available)"
        onPress={() => { }}
    />)

  return (
    <DNAContextMenu>
      <DNAContextMenu.Anchor>
        {children}
      </DNAContextMenu.Anchor>
      <DNAContextMenu.Items>
        {MenuItems}
      </DNAContextMenu.Items>
    </DNAContextMenu>
  )
}

export default DNADocumentContextMenu
